/**
 * ThermaSun - size selector state
 *
 * The size buttons on a product page (100g / 1kg / etc.) are not Shopify
 * variants. They are plain links pointing at separate products, so the theme
 * has no idea which one you are currently looking at and renders them all
 * identically. This marks the link that points at the page you are already on
 * with aria-current="page", which thermasun-brand.css then styles as selected.
 *
 * Scoped to .product-details so it can only ever touch the size row, never a
 * related-product link or a CTA elsewhere on the page.
 */
function markCurrentSize() {
  const here = window.location.pathname.replace(/\/+$/, '');

  document.querySelectorAll('.product-details a.button[href]').forEach((link) => {
    let path;

    try {
      path = new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/+$/, '');
    } catch (error) {
      return;
    }

    if (!path.startsWith('/products/')) return;

    if (path === here) {
      if (link.getAttribute('aria-current') !== 'page') {
        link.setAttribute('aria-current', 'page');
      }
    } else if (link.hasAttribute('aria-current')) {
      link.removeAttribute('aria-current');
    }
  });
}

markCurrentSize();

// Covers back/forward restores from the bfcache, where the module does not re-run.
window.addEventListener('pageshow', markCurrentSize);
